import { render, staticRenderFns } from "./Step3.vue?vue&type=template&id=5178d1c8&scoped=true"
import script from "./Step3.vue?vue&type=script&lang=js"
export * from "./Step3.vue?vue&type=script&lang=js"
import style0 from "./Step3.vue?vue&type=style&index=0&id=5178d1c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5178d1c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5178d1c8')) {
      api.createRecord('5178d1c8', component.options)
    } else {
      api.reload('5178d1c8', component.options)
    }
    module.hot.accept("./Step3.vue?vue&type=template&id=5178d1c8&scoped=true", function () {
      api.rerender('5178d1c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reservations/advance/steps/Step3.vue"
export default component.exports